import { FastConditionalStrategy } from 'utility-ts-strategy';
import { PlanFeedbackServant } from '../../suggestions/components/plan_feedback/servants/plan_feedback_servant';

export const AdvisorInitRedirectStrategy = new FastConditionalStrategy([
  ['ap-advisor.retain_suggestions.blocked_suggestions', PlanFeedbackServant.isPlanBlocked],
  ['.edit.default', PlanFeedbackServant.isPlanEditing],
  ['ap-advisor.student-plan-progress', PlanFeedbackServant.isPlanSentToStudent],
  ['.view.default', PlanFeedbackServant.isPlanReadOnlyMode]
]);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/strategies/ap_advisor_init_redirect_strategy.ts